<script lang="ts" setup>
    import { hasSlot } from '../../lib/VueHelpers'
    import '../../../css/choice.css';
import { onBeforeMount, reactive, watch } from 'vue';
    
    const props = defineProps<{
        modelValue?: boolean,
        disabled?: boolean
        title?: string,
        beforeChange?: (newVal:boolean) => Promise<boolean>
    }>();

    const compData = reactive<{
        checkBoxValue?: boolean
    }>({});

    const emit = defineEmits<{
        (e: "update:modelValue", value:boolean): void
    }>();

    onBeforeMount(() => 
        compData.checkBoxValue = props.modelValue
    );


    watch(() => props.modelValue, (newVal, _oldVal) => {
        compData.checkBoxValue = newVal;
    });

    async function onChange(evt: Event)
    {     
        const checkBoxEle = (evt.target as HTMLInputElement);

        // Verify we want to change the value
        if (checkBoxEle.checked != props.modelValue)
        {
            if (props.beforeChange)            
            {
                if (!await props.beforeChange(checkBoxEle.checked))
                {
                    checkBoxEle.checked = props.modelValue;
                    return;
                }
            }

            // Indicate the value changed
            emit("update:modelValue", checkBoxEle.checked);
        }
    }
</script>

<template>
    <span :title="props.title">
        <input 
            type='checkbox' 
            class="form-check-input input-border me-1" 
            :checked="compData.checkBoxValue" 
            :disabled="true === props.disabled"
            @change="onChange" />

        <span v-if="hasSlot()" class="me-2">
            <slot></slot>
        </span>
    </span>
</template>